"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./FilterChip.style"));
/*
active 상태는 외부에서 제어한다.
ex) FilterChip을 누르고 필터 UI 표시 & 변경사항이 존재할 때만 active 상태로 변경
*/


function FilterChip(_ref) {
  var onClick = _ref.onClick,
      iconName = _ref.iconName,
      activeIconName = _ref.activeIconName,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children;
  return jsx_runtime_1.jsxs("button", Object.assign({
    type: "button",
    css: [styles.container, active && styles.active],
    onClick: onClick
  }, {
    children: [jsx_runtime_1.jsx(Icon_1.default, {
      css: styles.icon,
      name: active ? activeIconName : iconName,
      alt: "filter"
    }, void 0), children]
  }), void 0);
}

exports.default = react_1.memo(FilterChip);